import dayjs from "dayjs";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

import { create } from "@/lib/store";
import { formatDate } from "@/shared/utils/formatDate";
import { Tree } from "@/Utils/Collections";
import { hashStorage } from "@/Utils/hashStorage";

const STORE_NAME = "Date Range";

interface DateRangeState {
  startDate: string | null;
  endDate: string | null;
  minDate: string | null;
  maxDate: string | null;
}

interface DateRangeActions {
  init: (tree: Tree) => void;
  setDateRange: (startDate: string | null, endDate: string | null) => void;
  setBoundaryRange: (minDate: string | null, maxDate: string | null) => void;
}

type StoreState = DateRangeState & DateRangeActions;

const defaultState: DateRangeState = {
  startDate: null,
  endDate: null,
  minDate: null,
  maxDate: null,
};
export const useDateRangeStore = create<StoreState>()(
  devtools(
    persist(
      (set) => ({
        ...defaultState,
        // TODO - replace with initialising store with props
        init: (tree: Tree) => {
          const extra = tree?.getNodeTreeExtras();
          const minDate = extra && dayjs(extra[0]?.min_date);
          const maxDate = extra && dayjs(extra[0]?.max_date);
          const defaultEndDate = maxDate;
          const defaultStartDate = maxDate?.subtract(12, "w");

          set({
            startDate: formatDate(defaultStartDate) ?? null,
            endDate: formatDate(defaultEndDate) ?? null,
            minDate: formatDate(minDate) ?? null,
            maxDate: formatDate(maxDate) ?? null,
          });
        },
        setDateRange: (startDate: string | null, endDate: string | null) => {
          set({ startDate, endDate });
        },
        setBoundaryRange: (minDate: string | null, maxDate: string | null) => {
          set({ minDate, maxDate });
        },
      }),
      {
        name: STORE_NAME,
        storage: createJSONStorage(() => hashStorage),
      }
    ),
    { name: STORE_NAME }
  )
);
